import React, {useEffect, useState} from 'react';
import Menu from "./components/Menu.jsx";
import PlaceSetting from "./components/PlaceSetting.jsx";

export default function DesignTool() {
	const [items, setItems] = useState(null);
	const [collections, setCollections] = useState(null);
	const [selected, setSelected] = useState(null);

	const handleUpdate = function(type, selection) {
		let selections = structuredClone(selected);
		if (type === 'collection' || type === 'random') {
			selections.charger = selection.charger ? items[selection.charger] : null;
			selections.dinner = selection.dinner ? items[selection.dinner] : null;
			selections.salad = selection.salad ? items[selection.salad] : null;
			// if the curated set doesn't have a tablecloth assigned, don't overwrite the current tablecloth
			if (selection.table) {
				selections.table = items[selection.table];
			}
		} else {
			selections[type] = selection;
		}
		if (type === 'collection') {
			selections.collection = selection;
		} else {
			selections.collection = null;
		}
		setSelected(selections);
	}

	useEffect(() => {
		fetch('/service/design-tool/design-tool').then(response => {
			response.json().then(json => {
				setItems(json.items);
				setCollections(json.collections);
				const params = new URLSearchParams(window.location.search);
				const defaultCollection = json.collections[Object.keys(json.collections)[0]];
				let defaultSelection = {
					collection: defaultCollection,
					charger: defaultCollection.charger ? json.items[defaultCollection.charger] : null,
					dinner: defaultCollection.dinner ? json.items[defaultCollection.dinner] : null,
					salad: defaultCollection.salad ? json.items[defaultCollection.salad] : null,
					table: defaultCollection.table ? json.items[defaultCollection.table] : null,
				};
				if (params.get('bgi')) {
					defaultSelection.collection = null;
					defaultSelection.table = json.items[params.get('bgi')] ?? null;
				}
				if (params.get('chg')) {
					defaultSelection.collection = null;
					defaultSelection.charger = json.items[params.get('chg')] ?? null;
				}
				if (params.get('dp')) {
					defaultSelection.collection = null;
					defaultSelection.dinner = json.items[params.get('dp')] ?? null;
				}
				if (params.get('sp')) {
					defaultSelection.collection = null;
					defaultSelection.salad = json.items[params.get('sp')] ?? null;
				}

				setSelected(defaultSelection);
			});
		});
	}, []);

	if (!items) {
		return (
			<div id="main-wrapper">
				<div id="loading"><p>Loading...</p></div>
			</div>
		)
	} else {
		return (
			<div id="main-wrapper">
				<Menu items={items} collections={collections} selected={selected} updateHandler={handleUpdate} />
				<div id="display">
					<PlaceSetting selected={selected} />
				</div>
			</div>
		)
	}
}